const backendBaseUrl = process.env.REACT_APP_BACKEND_URL || '';
const API_URL = `${backendBaseUrl.endsWith('/') ? backendBaseUrl.slice(0, -1) : backendBaseUrl}/api/v1`;

export default API_URL;

export const isProdEnv = process.env.REACT_APP_IS_PROD_ENV;
export const secretEncryptionKey = process.env.REACT_APP_SECRET_ENCRYPTION_KEY;
